import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';

import { EmpresaVinculo } from '../../../../models/EmpresaVinculo';

@Component({
  selector: 'app-selecionar-empresas.component',
  imports: [
    MatProgressSpinnerModule,
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatSelectModule,
    MatCheckboxModule,
    MatTableModule,
    MatPaginatorModule,
    MatSelectModule,
    MatSortModule,
  ],
  templateUrl: './selecionar-empresas.component.html',
  styleUrl: './selecionar-empresas.component.scss',
})
export class SelecionarEmpresasComponent implements OnInit {
  public isLoading = false;
  listaDeEmpresasOriginal: any[] = [];
  listaDeEmpresas: any[] = [];
  empresasSelecionadas: any[] = [];

  checkboxIndeterminate = true;
  checkboxChecked = false;

  public gruposBloqueados = new Set<number>();
  public gruposValores = new Map<
    number,
    { buscaUsuarios: boolean; buscaPessoas: boolean }
  >();

  constructor(
    public dialogRef: MatDialogRef<SelecionarEmpresasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.listaDeEmpresasOriginal = data.empresas || [];
    this.listaDeEmpresas = [...this.listaDeEmpresasOriginal];
  }

  ngOnInit(): void {
    const grupos = this.data.grupos || [];
    this.gruposBloqueados = new Set(grupos.map((g: any) => g.idGrupo));

    grupos.forEach((g: any) => {
      if (g.idGrupo != null) {
        this.gruposValores.set(g.idGrupo, {
          buscaUsuarios: !!g.buscaUsuarios,
          buscaPessoas: !!g.buscaPessoas,
        });
      }
    });

    this.listaDeEmpresas.forEach((empresa) => {
      if (this.gruposBloqueados.has(empresa.idGrupo)) {
        const valores = this.gruposValores.get(empresa.idGrupo);
        if (valores) {
          empresa.buscaUsuarios = valores.buscaUsuarios;
          empresa.buscaPessoas = valores.buscaPessoas;
        }
      }
    });
  }

  getCheckboxState(empresa: EmpresaVinculo): {
    checked: boolean;
    indeterminate: boolean;
  } {
    const { buscaUsuarios, buscaPessoas } = empresa;
    return {
      checked: buscaUsuarios && buscaPessoas,
      indeterminate:
        (buscaUsuarios || buscaPessoas) && !(buscaUsuarios && buscaPessoas),
    };
  }

  updateFieldText(event: Event) {
    const query = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (!query) {
      this.listaDeEmpresas = [...this.listaDeEmpresasOriginal];
      return;
    }

    this.listaDeEmpresas = this.listaDeEmpresasOriginal.filter((e) =>
      (e.nome || e.nome || '').toLowerCase().includes(query)
    );
  }

  empresaBloqueada(empresa: EmpresaVinculo): boolean {
    return (
      empresa.idGrupo !== undefined &&
      empresa.idGrupo !== null &&
      this.gruposBloqueados.has(empresa.idGrupo)
    );
  }

  isSelecionado(empresa: EmpresaVinculo): boolean {
    return this.empresasSelecionadas.some(
      (g) => g.idEmpresa === empresa.idEmpresa
    );
  }

  toggleGrupo(empresa: EmpresaVinculo, checked: boolean): void {
    empresa.buscaUsuarios = checked;
    empresa.buscaPessoas = checked;

    if (checked) {
      if (!this.isSelecionado(empresa)) {
        this.empresasSelecionadas.push(empresa);
      }
    } else {
      this.empresasSelecionadas = this.empresasSelecionadas.filter(
        (e) => e.idEmpresa !== empresa.idEmpresa
      );
    }
  }

  onToggleFilho(empresa: EmpresaVinculo) {
    const { checked, indeterminate } = this.getCheckboxState(empresa);

    if (checked || indeterminate) {
      if (!this.isSelecionado(empresa)) {
        this.empresasSelecionadas.push(empresa);
      }
    } else {
      this.empresasSelecionadas = this.empresasSelecionadas.filter(
        (e) => e.idEmpresa !== empresa.idEmpresa
      );
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onConfirm() {
    const idsEmpresasVinculadas = this.listaDeEmpresas.map((e) => e.idEmpresa);

    const empresasBloqueadas = this.listaDeEmpresas.filter((e) =>
      this.empresaBloqueada(e)
    );

    const empresasSelecionadas = this.empresasSelecionadas.filter(
      (e) => !this.empresaBloqueada(e)
    );

    this.dialogRef.close([
      empresasSelecionadas,
      empresasBloqueadas,
      idsEmpresasVinculadas,
    ]);
  }
}
